import React, { useContext } from "react";
import { SubdestajosContext } from "../../context/SubdestajosContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { AvanceModeContext } from "../../context/AvanceModeContext";
import AvancePickerMobile from "../cronograma/AvancePickerMobile";
import Rubro from "../common/Rubro";

const SubdestajoTabla = ({ subdestajo, getProyecto }) => {
  const { proyecto } = useContext(ProyectosContext);
  const { inputType } = useContext(AvanceModeContext);

  const { idProyecto, permiso } = proyecto;

  const { postAvanceSubDestajo } = useContext(SubdestajosContext);

  const enabled = () => {
    return ["admin", "supervisor"].includes(permiso);
  };

  const postAvance = (cont, isManual) => {
    postAvanceSubDestajo(
      subdestajo.idSubDestajo,
      cont,
      idProyecto,
      getProyecto,
      isManual
    );
  };

  return (
    <tr
      className={`border-bottom ${
        parseFloat(subdestajo.progreso) > 100 ? "concepto-aditivo" : ""
      }`}
    >
      <td className="ponderacion">
        <span className="bold">
          {subdestajo.ponderacion !== null &&
          subdestajo.ponderacion !== undefined &&
          !isNaN(parseInt(subdestajo.ponderacion))
            ? `${parseInt(subdestajo.ponderacion)}%`
            : "-"}
        </span>
      </td>
      <td className="rubro">
        <div className="row mx-0">
          <div className="col-2 px-0"></div>
          <div className="col-10 px-0">
            <Rubro
              completado={subdestajo.completado}
              nombre={subdestajo.nombre}
              className="p bold"
            />
          </div>
        </div>
      </td>
      <td className="text-center" style={{ width: 180 }}>
        {["admin", "supervisor"].includes(permiso) ? (
          <AvancePickerMobile
            permitirExcedente
            progreso={parseInt(subdestajo.progreso)}
            setCantidad={postAvance}
            disabled={!enabled()}
            intervalo={1}
            limite={100}
            inputType={inputType}
          />
        ) : (
          <p className="bold mb-0">{parseInt(subdestajo.progreso)}%</p>
        )}
      </td>
      <td />
      <td />
      <td />
      <td />
      {/*<td>
        <button className="btn btn-sm btn-light border me-2">
          <i className="fa fa-bell"></i>
        </button>
        <button className="btn btn-sm btn-light border me-2">
          <i className="fa fa-user"></i>
        </button>
        <button className="btn btn-sm btn-light border">
          <i className="fa fa-comment"></i>
        </button>
        </td>*/}
    </tr>
  );
};

export default SubdestajoTabla;
